var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h6', {
    staticClass: "mb-1 mt-1 text-center"
  }, [_vm._v("忘記密碼")]), _c('p', [_vm._v("請輸入您註冊的 Email，系統會發送密碼重置信")]), _vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form', {
    staticClass: "av-tooltip tooltip-label-bottom",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-label"
  }, [_vm._v("Email")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.email,
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "電子郵件"
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value;
      }
    }
  })]), _c('b-button', {
    staticClass: "btn-block primary-button",
    staticStyle: {
      "margin-top": "36px"
    },
    attrs: {
      "type": "submit",
      "variant": "primary",
      "size": "lg",
      "disabled": _vm.processing
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 送出 ")]), _c('div', {
    staticClass: "mt-4"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/' + _vm.$route.params.org_code + '/liff/login'
      }
    }
  }, [_vm._v("返回登入")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }